export const USER_PERMISSIONS = {
  UPLOAD: "UPLOAD",
};
